import React from 'react';
import Loadable from 'react-loadable';

import SkeletonFeaturedWidget from './components/LoadingState/LoadingState';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "SportsFeaturedWidget" */ './SportsFeaturedWidget'),
  modules: ['./SportsFeaturedWidget'],
  loading: () => <SkeletonFeaturedWidget />
});

export default LoadableWidget;
